import { unpurry } from "@suse-o11y/unpurry";
import { round as round_ } from "remeda";

export const round = unpurry(round_, 2);
